import Roles from './Roles';
export const studentMessagingRoles = [Roles.AnnouncementOfficer, Roles.Admin, Roles.SuperAdmin, Roles.Hod, Roles.DepartmentOfficer, Roles.FacultyOfficer, Roles.PgCoordinator];
export function canMessageStudents(roles = []) { return Roles.deepContains(roles, studentMessagingRoles); }
